/**
 * Order Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Gs1ParseResultVO } from './gs1ParseResultVO';
import { SkuBarcodeVO } from './skuBarcodeVO';


export interface BarcodeResolveResultVO { 
    /**
     * SKU ID
     */
    skuId?: number;
    /**
     * SKU Code
     */
    skuCode?: string;
    /**
     * Product (SPU) ID
     */
    spuId?: number;
    /**
     * Product (SPU) Code
     */
    spuCode?: string;
    /**
     * SKU Name
     */
    skuName?: string;
    /**
     * Full image list for the resolved SKU
     */
    imageList?: Array<string>;
    /**
     * The stored barcode value that matched the scan
     */
    matchedBarcodeValue?: string;
    /**
     * EXACT: scanned value matched a stored barcode directly. GS1_GTIN: scanned value\'s GTIN matched a stored GS1 barcode with a different lot/serial
     */
    matchType?: BarcodeResolveResultVO.MatchTypeEnum;
    /**
     * All barcodes registered for the resolved SKU
     */
    barcodes?: Array<SkuBarcodeVO>;
    /**
     * GS1 fields parsed from the scanned string; populated only when matchType is GS1_GTIN
     */
    gs1ParseResult?: Gs1ParseResultVO;
}
export namespace BarcodeResolveResultVO {
    export const MatchTypeEnum = {
        Exact: 'EXACT',
        Gs1Gtin: 'GS1_GTIN'
    } as const;
    export type MatchTypeEnum = typeof MatchTypeEnum[keyof typeof MatchTypeEnum];
}


